import { j as l } from "./AccesRecoveryIcon-CUPieIxT.js";
const s = () => /* @__PURE__ */ l.jsx("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ l.jsx(
  "path",
  {
    d: "M8.334 15v20H1.667V15zM15 35a3.333 3.333 0 0 1-3.333-3.334V15c0-.917.367-1.75.983-2.35L23.617 1.667l1.767 1.766c.45.45.733 1.067.733 1.75l-.05.534-1.583 7.616H35a3.333 3.333 0 0 1 3.334 3.333V20c0 .433-.084.833-.234 1.217l-5.033 11.75A3.31 3.31 0 0 1 30 35zm0-3.334h15.05L35 20v-3.334H20.35L22.234 7.8 15 15.05z",
    fill: "currentColor"
  }
) });
export {
  s as L
};
